import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AbsFormsComponent } from './abs-forms.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AbsFormsComponent],
  exports: [AbsFormsComponent]
})
export class AbsFormsModule { }
